import * as AppHttpKit from '@/utils/http/AppHttpKit';
/**
 * 以下是完成API接口调用的定义规范
 */
const NacosApi = {
    serverList:(data) => AppHttpKit.postJSON(`/v1/serverList`,data),
    queryInstances:(data) => AppHttpKit.postJSON(`/v1/queryInstances`,data),
}
export default NacosApi;
